<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <AttachmentsPrintGrid
      :attachments="project.roofHookWithEarthingAttachments"
      fieldName="roofHookWithEarthingAttachments"
      fieldDescription="roofHookWithEarthingAttachments_description"
      :maxImages="4"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('railsEarthed') }}</div>
        <div>{{ $t(project.enpalReport.railsEarthed) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.correctCableInputAttachments"
      fieldName="correctCableInputAttachments"
      fieldDescription="correctCableInputAttachments_description"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
